import script from "./OrderCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCenter.vue?vue&type=script&setup=true&lang=js"

import "./OrderCenter.vue?vue&type=style&index=0&id=69d20ce4&lang=less"

const __exports__ = script;

export default __exports__